module.exports = __webpack_public_path__ + "img/crib-pink.7f799b5a.svg";